module.exports = __webpack_public_path__ + "media/assets/images/icon_sina-a322a475f8ae3af12f648da0235f8da9.png";